<template>
  <div class="after_sales_list">
    <!--售后列表头部-->
    <div class="after_sales_list_top">
      <div class="w_percent17"><input type="text" placeholder="售后单号" v-model.trim="afterSalesNum"></div>
      <div class="w_percent17"><input type="text" placeholder="订单号" v-model.trim="orderNum"></div>
      <div>
        <el-select multiple collapse-tags v-model="selectAfterSalesType" :value="selectAfterSalesType" placeholder="售后类型">
          <el-option v-for="item in afterSalesTypeList"
                     :key="item.id"
                     :label="item.text"
                     :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div>
        <el-select v-model="selectAfterSalesStatus" :value="selectAfterSalesStatus" placeholder="售后状态">
          <el-option v-for="item in afterSalesStatusList"
                     :key="item.id"
                     :label="item.text"
                     :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div>
        <el-select v-model="selectStatusAccounting" :value="selectStatusAccounting" placeholder="结算状态">
          <el-option v-for="item in statusAccountingList"
                     :key="item.id"
                     :label="item.text"
                     :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div>
        <el-select v-model="selectAfterSalesReason" :value="selectAfterSalesReason" placeholder="售后原因">
          <el-option v-for="item in afterSalesReasonList"
                     :key="item.id"
                     :label="item.text"
                     :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div>
        <el-select v-model="selectRefundStatus" :value="selectRefundStatus" placeholder="买家退款状态">
          <el-option v-for="item in refundStatusList"
                     :key="item.id"
                     :label="item.text"
                     :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div>
        <el-select multiple collapse-tags v-model="selectSendChannel" :value="selectSendChannel" placeholder="发出渠道">
          <el-option v-for="item in sendChannelList"
                     :key="item.id"
                     :label="item.text"
                     :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div>
        <el-select v-model="selectAcceptanceChannel" :value="selectAcceptanceChannel" placeholder="受理渠道">
          <el-option v-for="item in acceptanceChannelList"
                     :key="item.id"
                     :label="item.text"
                     :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div>
        <el-select v-model="selectSourceStore" :value="selectSourceStore" placeholder="店铺来源">
          <el-option v-for="item in sourceStoreList"
                     :key="item.id"
                     :label="item.text"
                     :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div class="w_percent17"><input type="text" placeholder="退回运单号" v-model.trim="refuseOrderNum"></div>
      <div class="w62 h32 mr2 ml2">申请时间:</div>
      <div class="ml0">
        <el-date-picker
          v-model.trim="applyStartTime"
          type="datetime"
          placeholder="开始时间"
          format="yyyy/MM/dd HH:mm:ss">
        </el-date-picker>
      </div>
      <div class="w9 h32 mr2 ml0">~</div>
      <div class="ml0">
        <el-date-picker
          v-model.trim="applyEndTime"
          type="datetime"
          placeholder="结束时间"
          format="yyyy/MM/dd HH:mm:ss">
        </el-date-picker>
      </div>
      <div class="w62 h32 mr2 ml2">完成时间:</div>
      <div class="ml0">
        <el-date-picker
          v-model.trim="finishStartTime"
          type="datetime"
          placeholder="开始时间"
          format="yyyy/MM/dd HH:mm:ss">
        </el-date-picker>
      </div>
      <div class="w9 h32 mr2 ml0">~</div>
      <div class="ml0">
        <el-date-picker
          v-model.trim="finishEndTime"
          type="datetime"
          placeholder="结束时间"
          format="yyyy/MM/dd HH:mm:ss">
        </el-date-picker>
      </div>
      <div>
        <el-select multiple collapse-tags v-model="selectConditionTag" :value="selectConditionTag" placeholder="条件标签">
          <el-option v-for="item in conditionTag"
                     :key="item.id"
                     :label="item.text"
                     :value="item.id">
          </el-option>
        </el-select>
      </div>
      <button class="btn_normal mt10 mlpercent1 fl" @click="queryData()">查询</button>
      <button class="btn_normal mt10 mlpercent1 ml10 fl" @click="exportRefundExcel()">导出查询结果</button>
    </div>

    <!--售后列表列表-->
    <div class="after_sales_list_msg">
      <table class="table tb_border">
        <thead>
        <tr>
          <th>售后单号</th>
          <th>操作</th>
          <th>订单信息</th>
          <th>售后类型</th>
          <th>售后状态</th>
          <th>售后原因</th>
          <th>售后金额</th>
          <th>结算状态</th>
          <th>买家退款状态</th>
          <th>受理渠道</th>
          <th>来源店铺</th>
          <th>申请人</th>
          <th>受理人</th>
          <th>售后信息</th>
        </tr>
        </thead>
        <tbody v-if="list.length">
        <tr v-for="(item, index) in list" :key="index" :class="{'bgc' : item.ReStatusName === '拒绝售后' }">
          <td class="text_left">
            <p class="no_newline">内：<a title="内部单号" @click="goAfterSalesDetail(item)">{{item.RefundId}}</a></p>
            <p class="no_newline">外：{{item.OutRefundId}}</p>
          </td>
          <td style="max-width: 125px">
            <a class="no_newline mr5" v-if="item.ReStatusName === '待受理'" title="受理" @click="ctrlBtn('toAccept', item)">受理</a>
            <a class="no_newline mr5" v-if="item.ReStatusName === '待退货'" title="退回物流" @click="ctrlBtn('returnLogistic', item)">退回物流</a>
            <a class="no_newline mr5" v-if="item.ReStatusName === '待受理' || item.ReStatusName === '待退货' || item.ReStatusName === '拒绝售后'" @click="ctrlBtn('modifySalesDetail', item)" title="修改明细">修改明细</a>
<!--            <a class="no_newline mr5" v-if="item.ReStatusName === '待收货' && item.BackStoreroomName !== '自收'" title="撤回" @click="ctrlBtn('pullBack', item)">撤回</a>-->
            <a class="no_newline mr5" v-if="item.ReStatusName === '待收货' || item.ReStatusName === '待退货'" title="撤回" @click="ctrlBtn('pullBack', item)">撤回</a>
            <a class="no_newline mr5" v-if="item.ReStatusName === '待收货' && item.BackStoreroomName === '自收'" title="确认收货" @click="ctrlBtn('confirmReceipt', item)">确认收货</a>
            <a class="no_newline mr5" v-if="item.ReStatusName === '拒绝售后'" title="重新提交" @click="ctrlBtn('resubmit', item)">重新提交</a>
            <a class="no_newline mr5" title="日志" @click="ctrlBtn('log', item)">日志</a>
            <a class="no_newline mr5" v-if="item.ReStatusName === '售后成功' && (item.ReTypeName === '换货' || item.ReTypeName === '漏发') && !item.IsCreateOrder" title="换货新订单" @click="ctrlBtn('createExchange', item)">创建售后新订单</a>
<!--            <a class="no_newline mr5" v-if="item.ReStatusName === '待受理' || item.ReStatusName === '待退货' || item.ReStatusName === '拒绝售后'" @click="ctrlBtn('closeSalesAfter', item)" title="终止售后">终止售后</a>-->
            <a class="no_newline mr5" v-if="item.RefundMoney !== '待结算'" @click="ctrlBtn('closeSalesAfter', item)" title="终止售后">终止售后</a>
          </td>
          <td>
            <p class="no_newline"><a title="订单详情" @click="ctrlBtn('orderDetail', item)">{{item.OrderId}}</a></p>
            <p class="no_newline" v-if="item.OrderSysStatusName">({{item.OrderSysStatusName}})</p>
          </td>
          <td class="no_newline" v-if="item.ReTypeName"><a title="售后类型" @click="ctrlBtn('modifyAfterSalesType', item)">{{item.ReTypeName}}</a></td>
          <td class="no_newline" v-if="!item.ReTypeName"><a title="售后类型" @click="ctrlBtn('modifyAfterSalesType', item)">无</a></td>
          <td class="no_newline">{{item.ReStatusName}}</td>
          <td class="no_newline"><a title="售后原因" @click="ctrlBtn('modifySalesReasonList', item)">{{item.RefundReasonName}}</a></td>
          <td class="no_newline">{{item.RefundMoney}}</td>
          <td class="text_left">
            <p class="no_newline">状态：{{item.SettleStatusName}}</p>
            <p class="no_newline">金额：{{item.AgentSettleMoney}}</p>
          </td>
          <td class="text_left">
            <p class="no_newline">状态：{{item.TuiZtName}}</p>
            <p class="no_newline">
              金额：<a title="退款金额" @click="ctrlBtn('buyerRefundedAmount', item)">{{item.TuiMoney}}</a>
              <i v-if="!item.TuiMoney" class="iconfont icon-modify" @click="ctrlBtn('buyerRefundedAmount', item)"></i>
            </p>
          </td>
          <td>
            <p class="no_newline inb">
              {{item.BackStoreroomName}}
            </p>
            <a v-if="item.BackStoreroomName !== '自收' && item.BackStoreroomName" :href="'tencent://message/?uin=' + item.BackStoreroomQQ + '&Site=&Menu-=yes'">
              <img src="../../../assets/img/qq.gif" height="17" width="25"/>
            </a>
           <!-- <p class="no_newline" v-if="item.BackStoreroomName !== '自收' && item.BackStoreroomName">
              <a :href="'tencent://message/?uin=' + item.BackStoreroomQQ + '&Site=&Menu-=yes'">
                <img src="../../../assets/img/qq.gif" height="17" width="25"/>
              </a>
            </p> -->
          </td>
          <td class="no_newline">{{item.ShopName}}</td>
          <td class="no_newline">{{item.CreaterName}}</td>
          <td class="no_newline">{{item.CheckerName}}</td>
          <td class="text_left">
            <p class="no_newline">退回物流：<a title="运单号详情" @click="ctrlBtn('logisticNumDetail', item)">{{item.ExpressNum}}</a></p>
            <p class="no_newline">申请时间：{{item.CreateTime | time}}</p>
            <p class="no_newline">完成时间：{{item.RefundSuccessTime | time}}</p>
          </td>
        </tr>
        </tbody>
        <tbody v-if="!list.length">
        <tr>
          <td colspan="14">{{listErr}}</td>
        </tr>
        </tbody>
      </table>

      <!--分页-->
      <div class="text_right mt20">
        <el-pagination
          background
          :prev-text="'上一页'"
          :next-text="'下一页'"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5, 10, 15, 20]"
          :page-size="pageSize"
          layout="total, prev, pager, next, sizes, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>

    <!--弹出框-->
    <after-sales-embed-msg v-if="isShow && dialogShowType !== 'orderDetail'"
                               :title="dialogTitle"
                               :msg="orderMsg"
                               :showType="dialogShowType" @cancelbtn="getSelectDialogEmbed"></after-sales-embed-msg>

    <!--弹出框---订单详情  -->
    <order-list-embed-msg v-if="isShow && dialogShowType === 'orderDetail'"
                          :title="dialogTitle"
                          :showType="dialogShowType"
                          :orderMsg="orderMsg"
                          @cancelbtn="getSelectDialogEmbed"></order-list-embed-msg>

    <!--加载框-->
    <loading-dialog v-if="isLoading" :type="loadingType"></loading-dialog>

    <!--信息提示框-->
    <msg-dialog v-if="isMsg"
                :txt="txtMsg"
                :is-suc="isSuc"
                @closebtn="closeMsgDialog"></msg-dialog>
  </div>
</template>

<script type="es6">
  import AfterSalesEmbedMsg from './after-sales-embed-msg';
  import OrderListEmbedMsg from './order-list-embed-msg';
  import LoadingDialog from '../../public-component/loading-dialog';
  import MsgDialog from '../../public-component/msg-dialog';

  export default {
    name: 'after-sales-list',
    components: {AfterSalesEmbedMsg, OrderListEmbedMsg, LoadingDialog, MsgDialog},
    watch: {

    },
    data() {
      return {
        list: [], // 列表
        listErr: '', // 查询列表时的错误信息
        orderMsg: null, // 订单信息
        afterSalesNum: '', // 售后订单号
        orderNum: '', // 订单号
        afterSalesTypeList: [], // 售后类型列表
        selectAfterSalesType: '', // 选择的售后类型
        afterSalesStatusList: [], // 售后状态列表
        selectAfterSalesStatus: '', // 选择的售后状态
        statusAccountingList: [], // 结算状态列表
        selectStatusAccounting: '', // 选择的结算状态
        afterSalesReasonList: [], // 售后原因列表
        selectAfterSalesReason: '', // 选择的售后原因
        refundStatusList: [], // 退款列表
        selectRefundStatus: '', // 选择的退款类型
        sendChannelList: [], // 发出渠道列表
        selectSendChannel: [], // 选择的发出渠道
        acceptanceChannelList: [], // 受理渠道列表
        selectAcceptanceChannel: '', // 选择的受理渠道
        sourceStoreList: [], // 来源店铺列表
        selectSourceStore: '', // 选择的来源店铺
        conditionTag:[], // 条件标签下拉值
        selectConditionTag: '', // 选择的条件标签
        refuseOrderNum: '', // 退回运单号
        applyStartTime: '', // 申请开始时间
        applyEndTime: '', // 申请结束时间
        finishStartTime: '', // 完成开始时间
        finishEndTime: '', // 完成结束时间
        isLoading: false, // 是否显示加载框
        loadingType: 'NOP', // 加载页面类型
        isMsg: false, // 信息框显示
        isSuc: false, // 是否成功
        txtMsg: '信息框内容', // 信息框内容
        isShow: false, // 提示框显示
        dialogTitle: null, // 弹出框头部名
        dialogShowType: null, // 弹出框类型
        currentPage: 1, // 当前页数
        pageSize: 10, // 当前显示几条数据
        total: 0 // 总条数
      }
    },
    methods: {
      // 获取售后类型下拉框数据
      getRefundTypeList() {
        this.$axios.get(this.Global.getRefundTypeList).then((res) => {
          if (!res.data.errorMsg.length) {
            this.afterSalesTypeList = res.data.resData;
            // this.afterSalesTypeList.splice(0, 0, {id: '', text: '售后类型'});
            // this.selectAfterSalesType = '';
            if (!this.selectAfterSalesType) {
              this.selectAfterSalesType = '';
            }
          } else {
            this.afterSalesTypeList = [];
            this.selectAfterSalesType = res.data.errorMsg;
          }
        });
      },

      // 获取售后状态下拉数据
      getRefundReStatusList() {
        this.$axios.get(this.Global.getRefundReStatusList).then((res) => {
          if (!res.data.errorMsg.length) {
            this.afterSalesStatusList = res.data.resData;
            this.afterSalesStatusList.splice(0, 0, {id: '', text: '售后状态'});
            if (!this.selectAfterSalesStatus) {
              this.selectAfterSalesStatus = '';
            }
          } else {
            this.afterSalesStatusList = [];
            this.selectAfterSalesStatus = res.data.errorMsg;
          }
        });
      },

      // 获取结算状态下拉数据
      getSettleStatusList() {
        this.$axios.get(this.Global.getSettleStatusList).then((res) => {
          if (!res.data.errorMsg.length) {
            this.statusAccountingList = res.data.resData;
            this.statusAccountingList.splice(0, 0, {id: '', text: '结算状态'});
            this.selectStatusAccounting = '';
          } else {
            this.statusAccountingList = [];
            this.selectStatusAccounting = res.data.errorMsg;
          }
        });
      },

      // 获取售后原因下拉框数据
      getRefundReasonList() {
        this.$axios.get(this.Global.getRefundReasonList).then((res) => {
          if (!res.data.errorMsg.length) {
            this.afterSalesReasonList = res.data.resData;
            this.afterSalesReasonList.splice(0, 0, {id: '', text: '售后原因'});
            this.selectAfterSalesReason = '';
          } else {
            this.afterSalesReasonList = [];
            this.selectAfterSalesReason = res.data.errorMsg;
          }
        });
      },

      // 获取退款状态下拉数据
      getRefundTuiZtList() {
        this.$axios.get(this.Global.getRefundTuiZtList).then((res) => {
          if (!res.data.errorMsg.length) {
            this.refundStatusList = res.data.resData;
            this.refundStatusList.splice(0, 0, {id: '', text: '买家退款状态'});
            this.selectRefundStatus = '';
          } else {
            this.refundStatusList = [];
            this.selectRefundStatus = res.data.errorMsg;
          }
        });
      },

      // 获取售后受理渠道下拉数据
      getBackStoreroomList() {
        this.$axios.get(this.Global.getBackStoreroomList(null)).then((res) => {
          if (!res.data.errorMsg.length) {
            this.sendChannelList = res.data.resData;
            this.selectSendChannel = [];
            this.acceptanceChannelList = [];
            this.acceptanceChannelList.push({id: '', text: '受理渠道'});
            this.acceptanceChannelList = this.acceptanceChannelList.concat(this.sendChannelList);
            this.selectAcceptanceChannel = '';
          } else {
            this.acceptanceChannelList = [];
            this.selectAcceptanceChannel = res.data.errorMsg;
            this.sendChannelList = [];
            this.selectSendChannel = [];
          }
        });
      },

      // 获取平台店铺来源下拉框信息
      getAllPXOpenPlatformList() {
        this.$axios.get(this.Global.getAllPXOpenPlatformList).then((res) => {
          if (!res.data.errorMsg.length) {
            this.sourceStoreList = res.data.resData;
            this.sourceStoreList.splice(0, 0, {id: '', text: '来源店铺'});
            this.selectSourceStore = '';
          } else {
            // alert(res.data.errorMsg);
            this.sourceStoreList = [];
            this.selectSourceStore = res.data.errorMsg;
          }
        });
      },

      // 获取售后来源店铺下拉数据
      getAllPXShopList() {
        this.$axios.get(this.Global.getAllPXShopList).then((res) => {
          if (!res.data.errorMsg.length) {
            this.sourceStoreList = res.data.resData;
            this.sourceStoreList.splice(0, 0, {id: '', text: '来源店铺'});
            this.selectSourceStore = '';
          } else {
            this.sourceStoreList = [];
            this.selectSourceStore = res.data.errorMsg;
          }
        });
      },

      // 加载条件标签下拉框数据
      getFilterTagList() {
        this.$axios.get(this.Global.getFilterTagList).then(res => {
          if (!res.data.errorMsg.length) {
            this.conditionTag = res.data.resData;
            this.selectConditionTag = '';
          } else {
            this.conditionTag = [];
            this.selectConditionTag = res.data.errorMsg;
          }
        });
      },

      // 获取当前时间 + 30天前时间
      getTime() {
        const nowDate = new Date();
        this.applyStartTime = (new Date(nowDate - 1000 * 60 * 60 * 24 * 30)).setHours(0, 0, 0);;
        // this.applyStartTime.setHours(0, 0, 0);
        this.applyEndTime = (new Date()).setHours(23, 59, 59);
        // this.applyEndTime.setHours(23, 59, 59);
      },

      // 数据判断
      judgeData() {
        /*if (!this.applyStartTime) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请选择申请开始时间';
          return false;
        } else if (!this.applyEndTime) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请选择申请结束时间';
          return false;
        } else */
          if (this.applyStartTime > this.applyEndTime) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请选择申请时间的开始时间不能大于结束时间';
          return false;
        } else if (this.finishStartTime && !this.finishEndTime) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请选择完成结束时间';
          return false;
        } else if (!this.finishStartTime && this.finishEndTime) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请选择完成开始时间';
          return false;
        } else if (this.finishStartTime > this.finishEndTime) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请选择完成时间的开始时间不能大于结束时间';
          return false;
        }
        return true;
      },

      // 查询数据
      queryData() {
        if (this.judgeData()) {
          this.currentPage = 1;
          this.loadRefundPageData();
        }
      },

      // 售后列表分页数据
      loadRefundPageData() {
        const params = {
          RefundId: this.afterSalesNum,
          OrderId: this.orderNum,
          ReType: this.selectAfterSalesType,
          ReStatus: this.selectAfterSalesStatus,
          SettleStatus: this.selectStatusAccounting,
          RefundReasonId: this.selectAfterSalesReason,
          TuiZt: this.selectRefundStatus,
          BackStoreroomId: this.selectAcceptanceChannel,
          SendStoreroomIdList: this.selectSendChannel,
          ShopId: this.selectSourceStore,
          ExpressNum: this.refuseOrderNum,
          // BeginCreateTime: this.Global.timeFormatStart(this.applyStartTime),
          // EndCreateTime: this.Global.timeFormatEnd(this.applyEndTime),
          BeginCreateTime: this.Global.timeFormatEight(this.applyStartTime),
          EndCreateTime: this.Global.timeFormatEight(this.applyEndTime),
          // BeginRefundSuccessTime: this.Global.timeFormatStart(this.finishStartTime),
          // EndRefundSuccessTime: this.Global.timeFormatEnd(this.finishEndTime),
          BeginRefundSuccessTime: this.Global.timeFormatEight(this.finishStartTime),
          EndRefundSuccessTime: this.Global.timeFormatEight(this.finishEndTime),
          FilterTagList: this.selectConditionTag,
          pageIndex: this.currentPage,
          pageSize: this.pageSize
        };
        this.isLoading = true;
        this.$axios.post(this.Global.loadRefundPageData, params).then((res) => {
          let timer;
          const self = this;
          timer = setTimeout(function () {
            self.isLoading = false;
            clearTimeout(timer);
            if (res) {
              if (!res.data.errorMsg.length) {
                self.list = res.data.resData.DataList;
                self.total = res.data.resData.TotalCounts;
                if (!self.list.length) {
                  self.listErr = '暂时没有相关信息';
                }
              } else {
                self.list = [];
                self.listErr = res.data.errorMsg;
              }
            }
          }, 500);
        });
      },

      // 操作按钮
      ctrlBtn(type, msg) {
        this.isShow = true;
        this.dialogShowType = type;
        this.orderMsg = msg;
        switch (type) {
          case 'pullBack':
            this.dialogTitle = '撤回提示';
            break;
          case 'toAccept':
            this.dialogTitle = '售后受理';
            break;
          case 'closeSalesAfter':
            this.dialogTitle = '提示';
            break;
          case 'modifyAfterSalesType':
            this.dialogTitle = '修改售后类型';
            break;
          case 'modifySalesReasonList':
            this.dialogTitle = '修改售后原因';
            break;
          case 'modifySalesDetail':
            this.dialogTitle = '选择售后明细';
            break;
          case 'log':
            this.dialogTitle = '日志';
            break;
          case 'orderDetail':
            this.dialogTitle = '订单详情';
            break;
          case 'buyerRefundedAmount':
            this.dialogTitle = '录入退款金额';
            break;
          case 'logisticNumDetail':
            this.dialogTitle = '运单号：' + msg.ExpressNum + '异常收货信息';
            break;
          case 'confirmReceipt':
            this.dialogTitle = '确认收货';
            break;
          case 'resubmit':
            this.dialogTitle = '提示';
            break;
          case 'returnLogistic':
            this.dialogTitle = '退回物流';
            break;
          case 'createExchange':
            this.dialogTitle = '确认售后明细';
            break;
        }
      },

      // 导出售后列表数据
      exportRefundExcel() {
        // 参数
        let params = {
          RefundId: this.afterSalesNum,
            OrderId: this.orderNum,
            ReType: this.selectAfterSalesType,
            ReStatus: this.selectAfterSalesStatus,
            SettleStatus: this.selectStatusAccounting,
            RefundReasonId: this.selectAfterSalesReason,
            TuiZt: this.selectRefundStatus,
            BackStoreroomId: this.selectAcceptanceChannel,
            SendStoreroomIdList: this.selectSendChannel,
            ShopId: this.selectSourceStore,
            ExpressNum: this.refuseOrderNum,
            /*BeginCreateTime: this.Global.timeFormatStart(this.applyStartTime),
            EndCreateTime: this.Global.timeFormatEnd(this.applyEndTime),
            BeginRefundSuccessTime: this.Global.timeFormatStart(this.finishStartTime),
            EndRefundSuccessTime: this.Global.timeFormatEnd(this.finishEndTime),*/
            BeginCreateTime: this.Global.timeFormatEight(this.applyStartTime),
            EndCreateTime: this.Global.timeFormatEight(this.applyEndTime),
            BeginRefundSuccessTime: this.Global.timeFormatEight(this.finishStartTime),
            EndRefundSuccessTime: this.Global.timeFormatEight(this.finishEndTime),
            FilterTagList: this.selectConditionTag,
            pageIndex: this.currentPage,
            pageSize: this.pageSize
        };
        if (this.judgeData()) {
          this.isLoading = true;
          this.$axios.post(this.Global.exportRefundExcel, params).then((res) => {
            let timer;
            const self = this;
            timer = setTimeout(function () {
              self.isLoading = false;
              clearTimeout(timer);
              if (res) {
                if (!res.data.errorMsg.length) {
                  window.open(res.data.resData, '_blank');
                } else {
                  self.isMsg = true;
                  self.isSuc = false;
                  self.txtMsg = res.data.errorMsg;
                }
              }
            }, 500);
          });
        }
      },

      // 跳转售后详情
      goAfterSalesDetail(msg) {
        this.$router.push({
          path: '/home/as_list/after_detail',
          query: {
            salesAfterId: msg.RefundId
          }
        });
      },

      // 判断路由是否存在status
      judgeStatus() {
        // this.getTime();
        const nowDate = new Date();
        this.isShow = false;
        this.afterSalesNum = null;
        this.orderNum = null;
        this.refuseOrderNum = null;
        // this.applyStartTime = null;
        // this.applyEndTime = null;
        // console.log(typeof this.$route.query['status']);
        // console.log(this.$route.query['status']);
        if (this.$route.query['status'] === 'a') {
          this.applyStartTime = new Date(nowDate - 1000 * 60 * 60 * 24 * 30);
          this.applyEndTime = nowDate;
          this.finishStartTime = new Date(nowDate - 1000 * 60 * 60 * 24 * 2);
          this.finishEndTime = nowDate;
          // this.finishStartTime = null;
          // this.finishEndTime = null;
          this.selectAfterSalesType = 4;
          this.selectAfterSalesStatus = 7;
        } else if (this.$route.query['status'] === 2) {
          this.applyStartTime = new Date(nowDate - 1000 * 60 * 60 * 24 * 2);
          this.applyEndTime = nowDate;
          this.finishStartTime = null;
          this.finishEndTime = null;
          this.selectAfterSalesType = '';
          this.selectAfterSalesStatus = this.$route.query['status'];
        } else if (this.$route.query['status'] === 6) {
          this.applyStartTime = new Date(nowDate - 1000 * 60 * 60 * 24 * 30);
          this.applyEndTime = nowDate;
          this.finishStartTime = null;
          this.finishEndTime = null;
          this.selectAfterSalesType = '';
          this.selectAfterSalesStatus = this.$route.query['status'];
        }
        this.loadRefundPageData();
      },

      // 接收提示框传送的数据
      closeMsgDialog(e) {
        this.isMsg = e;
      },

      // 接收弹出框传送的数据
      getSelectDialogEmbed(e) {
        this.isShow = e.isShow;
        if (e.handleType) {
          this.loadRefundPageData();
        }
      },

      // 分页——当前页面显示条数改变
      handleSizeChange(val) {
        this.pageSize = val;
        this.loadRefundPageData();
      },

      // 分页——当前页改变
      handleCurrentChange(val) {
        this.currentPage = val;
        this.loadRefundPageData();
      }
    },
    created() {
      this.getTime();
      this.getRefundTypeList();
      this.getRefundReStatusList();
      this.getSettleStatusList();
      this.getRefundReasonList();
      this.getRefundTuiZtList();
      this.getBackStoreroomList();
      // this.getAllPXOpenPlatformList();
      this.getAllPXShopList();
      this.getFilterTagList();
      if (this.$route.query['orderNum']) {
        this.applyStartTime = null;
        this.applyEndTime = null;
        this.orderNum = this.$route.query['orderNum'];
        // console.log(this.afterSalesNum);
      }
      if (this.$route.query['status']) {
        // this.selectAfterSalesStatus = this.$route.query['status'];
        this.judgeStatus();
      } else {
        this.loadRefundPageData();
      }
    },
    activated() { // 只有keep-alive激活才会被使用
      if (sessionStorage.getItem('isRefresh') === 'true') { // 从左边的菜单进去刷新页面
        sessionStorage.setItem('isRefresh', 'false');
        this.getTime();
        this.isShow = false;
        this.afterSalesNum = null;
        this.orderNum = null;
        this.refuseOrderNum = null;
        this.selectAfterSalesType = '';
        this.selectAfterSalesStatus = '';
        // this.applyStartTime = null;
        // this.applyEndTime = null;
        this.finishStartTime = null;
        this.finishEndTime = null;
        this.getRefundTypeList();
        this.getRefundReStatusList();
        this.getSettleStatusList();
        this.getRefundReasonList();
        this.getRefundTuiZtList();
        this.getBackStoreroomList();
        this.getAllPXShopList();
        this.loadRefundPageData();
      } else {
        if (this.$route.query['status']) {
          this.judgeStatus();
        } else if (this.$route.query['orderNum']) {
          // this.getTime();
          this.applyStartTime = null;
          this.applyEndTime = null;
          this.isShow = false;
          this.orderNum = this.$route.query['orderNum'];
          this.afterSalesNum = null;
          this.refuseOrderNum = null;
          // this.applyStartTime = null;
          // this.applyEndTime = null;
          this.finishStartTime = null;
          this.finishEndTime = null;
          this.selectAfterSalesStatus = '';
          this.loadRefundPageData();
        }
      }
    },
    beforeRouteLeave(to, from, next) {
      to.meta.keepAlive = true;
      next();
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/css/style";
  @import "../../../assets/css/base-color";

  .after_sales_list {
    width: 100%;
    height: 100%;
    /*overflow: auto;*/
    background-color: $cfff;
    position: relative;

    .after_sales_list_top {
      /*margin-top: 10px;*/
      margin-bottom: 10px;
      /*height: 135px;*/
      max-height: 135px;
      /*padding-left: 1%;*/
      overflow: hidden;
      zoom: 1;

      & > div {
        display: inline-block;
        float: left;
        width: 13%;
        max-width: 150px;
        margin-left: 1%;
        margin-top: 10px;

        &.vertical_center {
          display: flex;
          align-items: center;
        }
      }

      .w_percent17 {
        width: 17%;
        max-width: 165px;
      }

      .w62 {
        width: 62px;
      }

      .w9 {
        width: 9px;
      }

    }

    .after_sales_list_msg {
      height: calc(100% - 148px);
      margin-left: 5px;
      margin-right: 5px;
      overflow: auto;
      font-size: 12px;

      .table {
        .bgc {
          background-color: rgba(255,0,0,.4);
        }

        td {
          min-width: 50px;
        }

        a {
          color: #169BD5;

          &:hover {
            cursor: pointer;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/sales-management/after-sales-list.vue